import imgProduk from '../../assets/image/img-produk-2.png';
import iconArrowRight from '../../assets/icon/icon_arrow_right.svg';
import { useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';

const CardProduk = (props) => {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => navigate(`/detail-produk?slug=${props?.produk?.slug}`)}
      className="cursor-pointer flex flex-col p-5 rounded-3xl bg-white">
      <img
        src={props?.produk?.image_url}
        alt="produk1"
        className="w-full object-contain mb-4"
      />
      <label className="text-textBlack font-semibold text-lg md:text-2xl">
        {props?.produk?.name}
      </label>
      <p className="text-textGray text-sm mt-2 line-clamp-3">
        {parse(props?.produk?.short_description ?? '')}
      </p>
      <img
        src={iconArrowRight}
        alt="icon arrow right"
        className="w-8 h-8 md:w-8 md:h-8 object-contain  mt-2"
      />
    </div>
  );
};

export default CardProduk;
